import {
  FETCH_CAMPAIGNS,
  FETCH_CAMPAIGNS_SUCCESS,
  FETCH_CAMPAIGNS_FAILED,
  EDIT_CAMPAIGN,
  SEND_CAMPAIGN,
  SEND_CAMPAIGN_SUCCESS,
  SEND_CAMPAIGN_FAILED
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, push, set, remove, update } from "firebase/database";
import { sendNotification } from './notificationactions';

export const CAMPAIGN_STATUS = {
  DRAFT: 'draft',
  SENT: 'sent',
  FAILED: 'failed'
};

export const fetchCampaigns = () => (dispatch) => {

  const {
    campaignsRef
  } = firebase;

  dispatch({
    type: FETCH_CAMPAIGNS,
    payload: null
  });

  onValue(campaignsRef, snapshot => {
    const data = snapshot.val();
    if (data) {
      const arr = Object.keys(data).map(i => ({ ...data[i], id: i }));
      dispatch({
        type: FETCH_CAMPAIGNS_SUCCESS,
        payload: arr.reverse()
      });
    } else {
      dispatch({
        type: FETCH_CAMPAIGNS_FAILED,
        payload: "No campaigns available."
      });
    }
  });
};

export const editCampaign = (campaign, method) => (dispatch) => {

  const {
    campaignsRef,
    campaignEditRef
  } = firebase;

  dispatch({
    type: EDIT_CAMPAIGN,
    payload: { method, campaign }
  });

  if (method === 'Add') {
    push(campaignsRef, campaign);
  } else if (method === 'Delete') {
    remove(campaignEditRef(campaign.id));
  } else {
    set(campaignEditRef(campaign.id), campaign);
  }
};

// A campaign is a saved, re-sendable push with its delivery result recorded against it.
// Sending reuses sendNotification so campaigns and one-off notifications share the same
// segmentation and the same honest accepted/failed accounting.
export const sendCampaign = (campaign) => async (dispatch) => {

  const {
    campaignEditRef
  } = firebase;

  dispatch({
    type: SEND_CAMPAIGN,
    payload: campaign
  });

  const result = await dispatch(sendNotification({
    title: campaign.title,
    body: campaign.body,
    usertype: campaign.usertype || 'All',
    devicetype: campaign.devicetype || 'All'
  }));

  // "accepted" is Expo's word — it is not proof the device displayed anything. Stored
  // under that name so the panel never reports it as delivery.
  const stats = {
    matchedUserCount: result?.matchedUserCount || 0,
    validTokenCount: result?.validTokenCount || 0,
    acceptedCount: result?.successCount || 0,
    failedCount: result?.errorCount || 0,
    invalidTokenCount: result?.invalidTokenCount || 0
  };

  const patch = {
    status: result?.ok ? CAMPAIGN_STATUS.SENT : CAMPAIGN_STATUS.FAILED,
    lastSentAt: new Date().getTime(),
    sendCount: (campaign.sendCount || 0) + 1,
    stats
  };

  if (campaign.id) {
    try {
      await update(campaignEditRef(campaign.id), patch);
    } catch (error) {
      // The push already went out; failing to record stats must not look like a send failure.
      console.error('[campaign] Could not record send stats.', error.message);
    }
  }

  if (result?.ok) {
    dispatch({
      type: SEND_CAMPAIGN_SUCCESS,
      payload: { ...campaign, ...patch }
    });
  } else {
    dispatch({
      type: SEND_CAMPAIGN_FAILED,
      payload: result?.message || "Campaign delivery failed."
    });
  }

  return { ...result, stats };
};
